const penaltiesArray = [
  "213.4(s) Excepted track",
  "213.4(b) Excepted track",
  "213.4(c) Excepted track",
  "213.4(d) Excepted track",
  "213.4()",
  "(1) Excepted track",
  "(2) Excepted track",
  "(3) Excepted track",
  "(4) Excepted track",
  "213.4(f) Excepted track",
  "213.7 Designation of qualified persons to supervise certain renewals and inspect track",
  "213.9 Classes of track: Operating speed limits",
  "213 11 Restoration or renewal of track under traffic conditions",
  "213.13 Measuring track not under load",
  "213.33 Drainage",
  "213.37 Vegetation",
  "213.53 Gage",
  "213.55 Track alinement",
  "213.37 Curves, elevation and speed limitations",
  "213.59 Elevation of curved track, runoff",
  "213. 63 Track surface",
  "213.65 Combined track alinement and surface deviations",
  "213.103 Ballast; ganaral",
  "213.109 Crossties",
  "(a) Material used",
  "(b) Distribution of ties",
  "(c) and (d) Sufficient number of non-defective ties",
  "(e) Joint tiss",
  "(f) Track constructed without crousties",
  "213.110 Gaga restraint measurement systems",
  "213.113 Defective rails",
  "213.115 Rail and mismatch",
  "213.118 Continuous welded rail plan (a) through",
  "213.119 Continuous welded rail plan contents (a) through (k)",
  "213.121 (a) Rail joints",
  "213.121 (b) Rail joints",
  "213.121 (c) Rail joints",
  "213.121 (d) Rail joints",
  "213.121 (e) Rail joints",
  "213 121 (f) Rail joints",
  "213 121 (g) Rail joints",
  "213.122 Torch cut rail",
  "213 123 Tie plates",
  "213.127 Rail Fastening Systems",
  "213.133 Tumouts and track crossings, generally",
  "213.135 Switches:",
  "(a) through (g)",
  "(h) chipped or worn points",
  "213.137 Frogs",
  "213.139 Spring rail frogs",
  "213 141 Self-guarded frogs",
  "213.143 Frog wuard rails and guard faces, gage",
  "Subpart E-Track appliances and track-related d",
  "213.205 Derails                                                                                                                        Subpart F-Inspection:",
  "213.233 Track inspections",
  "213.234 Automated inspection of track constructed with concrete crossties",
  "213.235 Switches, crossings, transition devices",
  "213.237 Inspection of rail",
  "213.238 Qualified operator",
  "213.239 Special inspections",
  "213 240 Continuous rail testine",
  "(b) Adopt necessary procedures",
  "(o) Record type of test and change in test",
  "(d) Qualifications",
  "(e) Field verification",
  "(f) Repeatable accuracy",
  "(g) Annual report",
  "213.241 Inspection records",
  "Subpart G-Train operations at track classes 6 anc",
  "213.305 Designation of qualified individuals, ganaral qualifications",
  "213.307 Classes of track: operating speed limits",
];

export const penaltiesArrayWithValuesOld = [
  { rule: "213.4(a) Excepted track2", values: [2500, 5000, 5000, 10000] },
  { rule: "213.4(b) Excepted track2", values: [2500, 5000, 5000, 10000] },
  { rule: "213.4(c) Excepted track2", values: [2500, 5000, 5000, 10000] },
  { rule: "213.4(d) Excepted track2", values: [2500, 5000, 5000, 10000] },
  { rule: "213.4(e): (1) Excepted track", values: [5000, 7500, 10000, 15000] },
  { rule: "213.4(e): (2) Excepted track", values: [7000, 10000, 14000, 20000] },
  { rule: "213.4(e): (3) Excepted track", values: [7000, 10000, 14000, 20000] },
  { rule: "213.4(e): (4) Excepted track", values: [5000, 7500, 10000, 15000] },
  { rule: "213.4(f) Excepted track", values: [2000, 4000, 4000, 8000] },
  { rule: "213.7 Designation of qualified persons to supervise certain renewals and inspect track", values: [1000, 2000, 2000, 4000] },
  { rule: "213.9 Classes of track: Operating speed limits", values: [2500, 5000, 5000, 10000] },
  { rule: "213.11 Restoration or renewal of track under traffic conditions", values: [2500, 5000, 5000, 10000] },
  { rule: "213.13 Measuring track not under load", values: [1000, 2000, 2000, 4000] },
  { rule: "213.33 Drainage", values: [2500, 5000, 5000, 10000] },
  { rule: "213.37 Vegetation", values: [1000, 2000, 2000, 4000] },
  { rule: "213.53 Gage", values: [5000, 7500, 10000, 15000] },
  { rule: "213.55 Track alinement", values: [5000, 7500, 10000, 15000] },
  { rule: "213.57 Curves; elevation and speed limitations", values: [2500, 5000, 5000, 10000] },
  { rule: "213.59 Elevation of curved track; runoff", values: [2500, 2500, 5000, 5000] },
  { rule: "213.63 Track surface", values: [5000, 7500, 10000, 15000] },
  { rule: "213.65 Combined track alinement and surface deviations", values: [5000, 7500, 10000, 15000] },
  { rule: "213.103 Ballast; general", values: [2500, 5000, 5000, 10000] },
  { rule: "213.109 Crossties (a) Material used", values: [1000, 2000, 2000, 4000] },
  { rule: "213.109 Crossties (b) Distribution of ties", values: [2500, 5000, 5000, 10000] },
  { rule: "213.109 Crossties (c) Sufficient number of nondefective ties, non-concrete", values: [1000, 2000, 2000, 4000] },
  { rule: "213.109 Crossties (d) Sufficient number of nondefective concrete ties", values: [1000, 2000, 2000, 4000] },
  { rule: "213.109 Crossties (e) Joint ties", values: [2500, 5000, 5000, 10000] },
  { rule: "213.109 Crossties (f) Track constructed without crossties", values: [2500, 5000, 5000, 10000] },
  { rule: "213.109 Crossties (g) Non-defective ties surrounding defective ties", values: [2500, 5000, 5000, 10000] },
  { rule: "213.109 Crossties (h) Tie plates", values: [2500, 5000, 5000, 10000] },
  { rule: "213.109 Crossties (i) Tie plates", values: [1000, 2000, 2000, 4000] },
  { rule: "213.110 Gage restraint measurement systems", values: [5000, 7500, 10000, 15000] },
  { rule: "213.113 Defective rails", values: [5000, 7500, 10000, 15000] },
  { rule: "213.115 Rail end mismatch", values: [2500, 5000, 5000, 10000] },
  { rule: "213.118 Continuous welded rail plan (a) through (e)", values: [5000, 7500, 10000, 15000] },
  { rule: "213.119 Continuous welded rail plan contents (a) through (k)", values: [5000, 7500, 10000, 15000] },
  { rule: "213.121 (a) Rail joints", values: [2500, 5000, 5000, 10000] },
  { rule: "213.121 (b) Rail joints", values: [2500, 5000, 5000, 10000] },
  { rule: "213.121 (c) Rail joints", values: [5000, 7500, 10000, 15000] },
  { rule: "213.121 (d) Rail joints", values: [2500, 5000, 5000, 10000] },
  { rule: "213.121 (e) Rail joints", values: [2500, 5000, 5000, 10000] },
  { rule: "213.121 (f) Rail joints", values: [2500, 5000, 5000, 10000] },
  { rule: "213.121 (g) Rail joints", values: [2500, 5000, 5000, 10000] },
  { rule: "213.121 (h) Rail joints", values: [5000, 7500, 10000, 15000] },
  { rule: "213.122 Torch cut rail", values: [2500, 5000, 5000, 10000] },
  { rule: "213.123 Tie plates", values: [1000, 2000, 2000, 4000] },
  { rule: "213.127 Rail Fastening Systems", values: [2500, 5000, 5000, 10000] },
  { rule: "213.133 Turnouts and track crossings, generally", values: [1000, 1000, 2000, 2000] },
  { rule: "213.135 Switches: (a) through (g)", values: [2500, 5000, 5000, 10000] },
  { rule: "213.135 Switches: (h) chipped or worn points", values: [5000, 7500, 10000, 15000] },
  { rule: "213.137 Frogs", values: [2500, 5000, 5000, 10000] },
  { rule: "213.139 Spring rail frogs", values: [2500, 5000, 5000, 10000] },
  { rule: "213.141 Self-guarded frogs", values: [2500, 5000, 5000, 10000] },
  { rule: "213.143 Frog guard rails and guard faces; gage", values: [2500, 5000, 5000, 10000] },
  { rule: "213.205 Derails", values: [2500, 5000, 5000, 10000] },
  { rule: "213.233 Track inspections", values: [2000, 4000, 4000, 8000] },
  { rule: "213.234 Automated inspection of track constructed with concrete crossties", values: [5000, 7500, 10000, 15000] },
  { rule: "213.235 Switches, crossings, transition devices", values: [2000, 4000, 4000, 8000] },
  { rule: "213.237 Inspection of rail", values: [2500, 5000, 5000, 10000] },
  { rule: "213.238 Qualified operator", values: [2500, 5000, 5000, 10000] },
  { rule: "213.239 Special inspections", values: [2500, 5000, 5000, 10000] },
  { rule: "213.240 Continuous rail testing (b) Adopt necessary procedures", values: [5000, 7500, 10000, 15000] },
  { rule: "213.240 Continuous rail testing (c) Record type of test and change in test", values: [2500, 5000, 5000, 10000] },
  { rule: "213.240 Continuous rail testing (d) Qualifications", values: [2500, 5000, 5000, 10000] },
  { rule: "213.240 Continuous rail testing (e) Field verification", values: [5000, 7500, 10000, 15000] },
  { rule: "213.240 Continuous rail testing (f) Repeatable accuracy", values: [5000, 7500, 10000, 15000] },
  { rule: "213.240 Continuous rail testing (g) Annual report", values: [2500, 5000, 5000, 10000] },
  { rule: "213.241 Inspection records", values: [1000, 1000, 2000, 2000] },
  { rule: "213.305 Designation of qualified individuals; general qualifications", values: [1000, 2000, 2000, 4000] },
  { rule: "213.307 Classes of track: operating speed limits", values: [2500, 5000, 5000, 10000] },
  { rule: "213.309 Restoration or renewal of track under traffic conditions", values: [2500, 5000, 5000, 10000] },
  { rule: "213.311 Measuring track not under load", values: [1000, 2000, 2000, 4000] },
  { rule: "213.319 Drainage", values: [2500, 5000, 5000, 10000] },
  { rule: "213.321 Vegetation", values: [1000, 2000, 2000, 4000] },
  { rule: "213.323 Track gage", values: [5000, 7500, 10000, 15000] },
  { rule: "213.327 Track alinement", values: [5000, 7500, 10000, 15000] },
  { rule: "213.329 Curves; elevation and speed limits", values: [2500, 5000, 5000, 10000] },
  { rule: "213.331 Track surface", values: [5000, 7500, 10000, 15000] },
  { rule: "213.332 Combined track alinement and surface deviations", values: [5000, 7500, 10000, 15000] },
  { rule: "213.333 Automated vehicle-based inspection systems", values: [5000, 7500, 10000, 15000] },
  { rule: "213.335 Crossties (a) Material used", values: [1000, 2000, 2000, 4000] },
  { rule: "213.335 Crossties (b) Distribution of ties", values: [2500, 5000, 5000, 10000] },
  { rule: "213.335 Crossties (c) Sufficient number of nondefective ties, non-concrete", values: [1000, 2000, 2000, 4000] },
  { rule: "213.335 Crossties (d) Sufficient number of nondefective concrete ties", values: [1000, 2000, 2000, 4000] },
  { rule: "213.335 Crossties (e) Joint ties", values: [2500, 5000, 5000, 10000] },
  { rule: "213.335 Crossties (f) Track constructed without crossties", values: [2500, 5000, 5000, 10000] },
  { rule: "213.335 Crossties (g) Non-defective ties surrounding defective ties", values: [2500, 5000, 5000, 10000] },
  { rule: "213.335 Crossties (h) Tie plates", values: [2500, 5000, 5000, 10000] },
  { rule: "213.335 Crossties (i) Tie plates", values: [1000, 2000, 2000, 4000] },
  { rule: "213.337 Defective rails", values: [5000, 7500, 10000, 15000] },
  { rule: "213.339 Inspection of rail in service", values: [2500, 5000, 5000, 10000] },
  { rule: "213.341 Inspection of new rail", values: [2500, 5000, 5000, 10000] },
  { rule: "213.343 Continuous welded rail (a) through (h)", values: [5000, 7500, 10000, 15000] },
  { rule: "213.345 Vehicle/track system qualification: (a) through (d)", values: [5000, 7500, 10000, 15000] },
  { rule: "213.345 Vehicle/track system qualification: (e) through (i)", values: [2500, 5000, 5000, 10000] },
  { rule: "213.347 Automotive or railroad crossings at grade", values: [5000, 7500, 10000, 15000] },
  { rule: "213.349 Rail end mismatch", values: [2500, 5000, 5000, 10000] },
  { rule: "213.351 (a) Rail joints", values: [2500, 5000, 5000, 10000] },
  { rule: "213.351 (b) Rail joints", values: [2500, 5000, 5000, 10000] },
  { rule: "213.351 (c) Rail joints", values: [5000, 7500, 10000, 15000] },
  { rule: "213.351 (d) Rail joints", values: [2500, 5000, 5000, 10000] },
  { rule: "213.351 (e) Rail joints", values: [2500, 5000, 5000, 10000] },
  { rule: "213.351 (f) Rail joints", values: [5000, 7500, 10000, 15000] },
  { rule: "213.351 (g) Rail joints", values: [5000, 7500, 10000, 15000] },
  { rule: "213.352 Torch cut rails", values: [2500, 5000, 5000, 10000] },
  { rule: "213.353 Turnouts, crossovers, transition devices", values: [1000, 2000, 2000, 4000] },
  { rule: "213.355 Frog guard rails and guard faces; gage", values: [2500, 5000, 5000, 10000] },
  { rule: "213.357 Derails", values: [2500, 5000, 5000, 10000] },
  { rule: "213.359 Track stiffness", values: [5000, 7500, 10000, 15000] },
  { rule: "213.361 Right of way", values: [5000, 7500, 10000, 15000] },
  { rule: "213.365 Visual inspections", values: [2500, 5000, 5000, 10000] },
  { rule: "213.367 Special inspections", values: [2500, 5000, 5000, 10000] },
  { rule: "213.369 Inspections records", values: [2000, 4000, 4000, 8000] },
];

export const penaltiesArrayWithValues = [
  {
    rule: "213.4(a) Excepted track2",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.4(b) Excepted track2",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.4(c) Excepted track2",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.4(d) Excepted track2",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.4(e): (1) Excepted track",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.4(e): (2) Excepted track",
    notwillfull: 14000,
    willfull: 20000,
  },
  {
    rule: "213.4(e): (3) Excepted track",
    notwillfull: 14000,
    willfull: 20000,
  },
  {
    rule: "213.4(e): (4) Excepted track",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.4(f) Excepted track",
    notwillfull: 4000,
    willfull: 8000,
  },
  {
    rule: "213.7 Designation of qualified persons to supervise certain renewals and inspect track",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.9 Classes of track: Operating speed limits",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.11 Restoration or renewal of track under traffic conditions",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.13 Measuring track not under load",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.33 Drainage",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.37 Vegetation",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.53 Gage",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.55 Track alinement",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.57 Curves; elevation and speed limitations",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.59 Elevation of curved track; runoff",
    notwillfull: 5000,
    willfull: 5000,
  },
  {
    rule: "213.63 Track surface",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.65 Combined track alinement and surface deviations",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.103 Ballast; general",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.109 Crossties (a) Material used",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.109 Crossties (b) Distribution of ties",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.109 Crossties (c) Sufficient number of nondefective ties, non-concrete",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.109 Crossties (d) Sufficient number of nondefective concrete ties",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.109 Crossties (e) Joint ties",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.109 Crossties (f) Track constructed without crossties",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.109 Crossties (g) Non-defective ties surrounding defective ties",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.109 Crossties (h) Tie plates",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.109 Crossties (i) Tie plates",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.110 Gage restraint measurement systems",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.113 Defective rails",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.115 Rail end mismatch",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.118 Continuous welded rail plan (a) through (e)",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.119 Continuous welded rail plan contents (a) through (k)",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.121 (a) Rail joints",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.121 (b) Rail joints",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.121 (c) Rail joints",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.121 (d) Rail joints",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.121 (e) Rail joints",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.121 (f) Rail joints",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.121 (g) Rail joints",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.121 (h) Rail joints",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.122 Torch cut rail",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.123 Tie plates",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.127 Rail Fastening Systems",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.133 Turnouts and track crossings, generally",
    notwillfull: 2000,
    willfull: 2000,
  },
  {
    rule: "213.135 Switches: (a) through (g)",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.135 Switches: (h) chipped or worn points",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.137 Frogs",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.139 Spring rail frogs",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.141 Self-guarded frogs",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.143 Frog guard rails and guard faces; gage",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.205 Derails",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.233 Track inspections",
    notwillfull: 4000,
    willfull: 8000,
  },
  {
    rule: "213.234 Automated inspection of track constructed with concrete crossties",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.235 Switches, crossings, transition devices",
    notwillfull: 4000,
    willfull: 8000,
  },
  {
    rule: "213.237 Inspection of rail",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.238 Qualified operator",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.239 Special inspections",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.240 Continuous rail testing (b) Adopt necessary procedures",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.240 Continuous rail testing (c) Record type of test and change in test",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.240 Continuous rail testing (d) Qualifications",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.240 Continuous rail testing (e) Field verification",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.240 Continuous rail testing (f) Repeatable accuracy",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.240 Continuous rail testing (g) Annual report",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.241 Inspection records",
    notwillfull: 2000,
    willfull: 2000,
  },
  {
    rule: "213.305 Designation of qualified individuals; general qualifications",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.307 Classes of track: operating speed limits",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.309 Restoration or renewal of track under traffic conditions",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.311 Measuring track not under load",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.319 Drainage",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.321 Vegetation",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.323 Track gage",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.327 Track alinement",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.329 Curves; elevation and speed limits",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.331 Track surface",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.332 Combined track alinement and surface deviations",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.333 Automated vehicle-based inspection systems",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.335 Crossties (a) Material used",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.335 Crossties (b) Distribution of ties",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.335 Crossties (c) Sufficient number of nondefective ties, non-concrete",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.335 Crossties (d) Sufficient number of nondefective concrete ties",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.335 Crossties (e) Joint ties",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.335 Crossties (f) Track constructed without crossties",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.335 Crossties (g) Non-defective ties surrounding defective ties",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.335 Crossties (h) Tie plates",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.335 Crossties (i) Tie plates",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.337 Defective rails",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.339 Inspection of rail in service",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.341 Inspection of new rail",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.343 Continuous welded rail (a) through (h)",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.345 Vehicle/track system qualification: (a) through (d)",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.345 Vehicle/track system qualification: (e) through (i)",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.347 Automotive or railroad crossings at grade",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.349 Rail end mismatch",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.351 (a) Rail joints",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.351 (b) Rail joints",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.351 (c) Rail joints",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.351 (d) Rail joints",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.351 (e) Rail joints",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.351 (f) Rail joints",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.351 (g) Rail joints",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.352 Torch cut rails",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.353 Turnouts, crossovers, transition devices",
    notwillfull: 2000,
    willfull: 4000,
  },
  {
    rule: "213.355 Frog guard rails and guard faces; gage",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.357 Derails",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.359 Track stiffness",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.361 Right of way",
    notwillfull: 10000,
    willfull: 15000,
  },
  {
    rule: "213.365 Visual inspections",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.367 Special inspections",
    notwillfull: 5000,
    willfull: 10000,
  },
  {
    rule: "213.369 Inspections records",
    notwillfull: 4000,
    willfull: 8000,
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/FRA/TrackViolationReport/CivilPenalties_213.js